import { ADModalBody, ADModalFooter } from "src/componentsUtils/AdvancedDragModal";
import { GlassInputControl, GlassInputGroup } from "./GlassInput";
import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { MapitStateContext } from "src/states/MapitState";
import { GlassButton, GlassButtonRow } from "./GlassButtons";
import { DataDivisionType, LayerInfo } from "src/common/managers/Types";
import { Typeahead } from "react-bootstrap-typeahead";
import { Localization } from "@viamap/viamap2-common";
import { GenerateGeomUtils } from "src/managers/GenerateGeomUtils";
import jsPDF, { TextOptionsLight } from "jspdf";
import chroma from "chroma-js";
import { VLine } from "./MitGlassComponents";
import { Spinner } from "react-bootstrap";
import { MarkData } from "./MarkData";
import { message } from "./Message";
import { wfsEndpoints } from "src/dataCollector/WFSCollectorEndpoints";
import { DC } from "src/dataCollector/DataCollector";
import { MIBIcon } from "src/componentsUtils/MIBIcon";
import { splitIntoParts } from "./DatarapportShared";

export function MarkRapport(props: {
   currentRapport: string,
   availableRapports: { value: string, label: string }[],
   onSelectRapport: (a: string) => void,
   onGenerate: (data: any, pdf: jsPDF) => void
}) {
   const { state: mapitState } = useContext(MapitStateContext);

   const [loading, setLoading] = useState(false);
   const [year, setYear] = useState<number>(LatestWFSMarkerLag());

   let usableLayers = useMemo(() => {
      return Object.values(mapitState.layers).filter(layer => layer.propertiesInGeoJson?.includes("SFEnummer"));
   }, [mapitState.layers])

   const [layerId, setLayerId] = useState<number[]>(usableLayers.map((a) => a.layerId));

   useEffect(() => {
      setLayerId((a) => a.filter((b) => usableLayers.map((a) => a.layerId).includes(b)));
   }, [mapitState.layers])

   let colorList = useMemo(() => {
      return SFEAndColorList(
         layerId.map((a) => mapitState.layers[a])
      );
   }, [layerId])

   return (
      <>
         <ADModalBody>
            <GlassInputGroup>
               <label>{Localization.getText("Document")}</label>
               <GlassInputControl>
                  <select disabled={false}
                     value={props.currentRapport}
                     onChange={(e) => {
                        let value = e.currentTarget.value;
                        props.onSelectRapport(value);
                     }}>
                     {
                        props.availableRapports.map((a) => {
                           return (
                              <option key={a.value} value={a.value}>{a.label}</option>
                           )
                        })
                     }
                  </select>
               </GlassInputControl>
               <label>{Localization.getText("Year")}</label>
               <GlassInputControl>
                  <select disabled={false}
                     value={year}
                     onChange={(e) => {
                        let value = parseInt(e.currentTarget.value, 10);
                        setYear(value);
                     }}>
                     {WFSMarkerLag().map((a) => {
                        return (
                           <Fragment key={a}><option value={a}>{a}</option></Fragment>
                        )
                     })}
                  </select>
               </GlassInputControl>
               <label>{Localization.getText("Layers")}</label>
               <Typeahead
                  multiple={true}
                  id="layerTypeahead"
                  options={usableLayers.map((a) => ({ id: a.layerId, datasetname: a.datasetname }))}
                  labelKey={"datasetname"}
                  placeholder={Localization.getText("please select") + " " + Localization.getText("layer")}
                  emptyLabel={Localization.getText("No results found")}
                  onChange={(selected) => setLayerId(selected.map((a: any) => a.id))}
                  selected={usableLayers.map((a) => ({ id: a.layerId, datasetname: a.datasetname })).filter((a) => layerId.includes(a.id))}
               />
               <label></label>
               <GlassButtonRow>
                  <GlassButton onClick={() => setLayerId(usableLayers.map((a) => a.layerId))}>{Localization.getText("Select All")}</GlassButton>
                  <GlassButton onClick={() => setLayerId([])}>{Localization.getText("Remove All")}</GlassButton>
               </GlassButtonRow>
               <VLine color={"#9d9d9d"} /><VLine color={"#9d9d9d"} />
               <label>{Localization.getText("Properties")} {colorList.length}</label>
               <div style={{ display: "flex", flexWrap: "wrap", gap: "2px" }}>
                  {colorList.map((a) => {
                     return (
                        <div
                           key={a.sfe}
                           title={a.sfe + ""}
                           style={{ background: a.color, borderRadius: "5px", padding: "3px", display: "flex", justifyContent: "center" }}>
                           <MIBIcon icon="property" style={{ aspectRatio: "1", color: "white" }} />
                        </div>
                     )
                  })}


               </div>
            </GlassInputGroup>


         </ADModalBody>
         <ADModalFooter>
            {loading ? <Spinner /> : <GlassButton disabled={!colorList.length} onClick={async () => {
               setLoading(true);
               try {
                  let data = await hentDataOgBelligenhed(colorList, year)
                  let pdf = createPDF(data, colorList, year);
                  if (pdf) {
                     props.onGenerate(data, pdf);
                  }
               } catch (e: unknown) {
                  if (e instanceof Error) {
                     message.error(Localization.getFormattedText("An error occurred while generating the report. Please try again later or contact support. Error details: {err}", { err: e.message }));
                  } else {
                     message.error(Localization.getText("An error occurred while generating the report. Please try again later or contact support."));
                  }
                  setLoading(() => false);
               }
            }}
            >{Localization.getText("Generate")}</GlassButton>}
         </ADModalFooter>
      </>
   );
}



async function hentDataOgBelligenhed(liste: { sfe: number }[], årstal: number) {
   let marker = await MarkData.hentMarkerFraSFEListe(liste, årstal);
   let adresser = await DC.DF_GQL.EBR.EBRAdresseOgPunkt(liste.map((a) => a.sfe + ""));
   return marker.map((item, idx) => ({ ...item, properties: { ...item.properties, adresse: adresser[idx].betegnelse } }));
}

function SFEAndColorList(layerInfoArr: LayerInfo[]) {
   let list: { sfe: number, color: string }[] = []
   let sfeList = new Set<number>();
   let validLayers = layerInfoArr.filter(layer => layer.propertiesInGeoJson?.includes("SFEnummer"));

   validLayers.forEach(layer => {
      let getColor = (_properties) => layer.styling.color && chroma(layer.styling.color).hex("rgb") || "black";
      if (layer.styling.colorByProperty) {
         if (layer.styling.colorByValue?.divisions?.type == DataDivisionType.Discrete) {
            let style = layer.styling
            getColor = (properties) => {
               if (style.colorByProperty) {
                  let x = GenerateGeomUtils.getColorByValueDiscrete(undefined as any, properties[style.colorByProperty], style.colorByValue?.divisions, style.outsideColorRange);
                  return x.color && chroma(x.color).hex("rgb") || "black";
               }
               return "black";
            }
         } else if (layer.styling.colorByValue?.divisions?.type == DataDivisionType.Continous) {
            let style = layer.styling
            getColor = (properties) => {
               if (style.colorByProperty) {
                  let x = GenerateGeomUtils.getColorByValueNummeric(undefined as any, properties[style.colorByProperty], style.colorByValue?.divisions, style.outsideColorRange);
                  return x.color && chroma(x.color).hex("rgb") || "black";
               }
               return "black";
            }
         }
      }
      layer.geoJson?.features?.forEach(feature => {
         let sfe = feature.properties?.SFEnummer;
         if (sfe && typeof sfe === "string") {
            sfe = parseInt(sfe)
         }
         if (sfe && !sfeList.has(sfe)) {
            sfeList.add(sfe);
            list.push({ sfe: sfe, color: getColor(feature.properties) });
         }
      });
   });
   return list;
}

function createPDF(data: any[], colorList: { sfe: number, color: string }[], year: number): jsPDF | null {

   let doc = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });

   const fr = MarkData.haFormat();
   const arealFormat = (nr: number) => fr(nr).format


   doc.text("Markoversigt", 110, 10, { align: "center" });
   doc.setFontSize(7);
   doc.text("Marktabel " + year, 15, 10);
   doc.text("Mapit", 15, 13);
   doc.text("Dato: " + new Date().toLocaleDateString("da-dk"), 220 - 25, 10, { align: "right" });
   doc.text("Side: 1", 220 - 25, 13, { align: "right" });
   let currentPage = 1;

   if (data.length == 0) {
      return doc;
   }

   let top = 15;
   let left = 15;
   let height = 5;

   let headerHeight = 14 + 5;
   let totalHeight = 5;
   doc.setFontSize(12);
   data.forEach((a) => {
      if (!a) return;
      if (!a.marker) {
         a.marker = [];
      }
      let x = a.properties;

      let marker = a.marker.toSorted(MarkData.MarkDataSorter).map((a) => a.properties);
      let fnLeng = (arr: typeof marker) => (arr.length * 2) * height + headerHeight + totalHeight;
      let length = fnLeng(marker);
      let resP = [...marker];
      let parts = splitIntoParts(resP, 260, fnLeng);
      let start = top;
      parts.forEach((part, idx) => {
         length = fnLeng(part) - (idx ? height - 1 : height);

         if (top + length > 260 && top !== 15) {
            doc.cellAddPage();
            currentPage++;
            doc.setFontSize(7);
            doc.setFont(undefined as any, "normal");
            doc.text("Marktabel", 15, 10);
            doc.text("Mapit", 15, 13);
            doc.text("Dato: " + new Date().toLocaleDateString("da-dk"), 220 - 25, 10, { align: "right" });
            doc.text("Side: " + currentPage, 220 - 25, 13, { align: "right" });
            top = 15;
         } else if (idx > 0) {
            top += 2;
            doc.setFillColor("#000000");
         }
         start = top;
         // doc.cellAddPage();
         if (idx == 0) {
            doc.setFontSize(12);
            customCell(doc, left, top, 10, 14, " ", 0, "left");
            customCell(doc, left + 10, top, 170, 14, x.adresse, 0, "left");
            doc.setFontSize(9);
            doc.text("SFE: " + x.SFEnummer, 27, top + 7.5);
            top += 9;
         } else {
            if (colorList.filter((b) => b.sfe == a.properties.SFEnummer)[0]) doc.setFillColor(colorList.filter((b) => b.sfe == a.properties.SFEnummer)[0].color);
            doc.rect(top, start, 180, height, "FD");
            doc.setFillColor("#000000");
            top += height;
         }
         doc.setFontSize(12);
         customCell(doc, left, top, 10, height, " ", 1, "left")
         customCell(doc, left + 10, top, 30, height, "Marknr", 1, "left", true)
         customCell(doc, left + 40, top, 50, height, "Markblok", 1, "left", true)
         customCell(doc, left + 90, top, 30, height, "På ejd.", 1, "left", true)
         customCell(doc, left + 120, top, 30, height, "Areal", 1, "left", true)
         customCell(doc, left + 150, top, 30, height, "Ansøgt", 1, "left", true)
         top += 5;
         customCell(doc, left + 10, top, 170, height, "Afgrøde", 1, "left", true)

         part.forEach((a, idx) => {
            top += 5;
            customCell(doc, left, top, 10, height, " ", 2 + idx, "left")
            customCell(doc, left + 10, top, 30, height, MarkData.safeString(a.Marknr), 2 + idx, "left")
            customCell(doc, left + 40, top, 50, height, MarkData.safeString(a.Markblok), 2 + idx, "left")
            customCell(doc, left + 90, top, 30, height, arealFormat((parseFloat(a.IMK_areal) * a.overlap / a.area) * 10000) || " ", 2 + idx, "right")
            customCell(doc, left + 120, top, 30, height, arealFormat(parseFloat(a.IMK_areal) * 10000) || " ", 2 + idx, "right")
            customCell(doc, left + 150, top, 30, height, arealFormat(parseFloat(a.GBanmeldt) * 10000) || " ", 2 + idx, "right")
            top += 5;
            let i = 0;
            while (doc.getTextWidth(a.Afgroede) > 160) {
               i++;
               doc.setFontSize(12 - i);
            }
            customCell(doc, left + 10, top, 170, height, MarkData.safeString(a.Afgroede), 1, "left")
            doc.setFontSize(12);
         })
         if (colorList.filter((b) => b.sfe == a.properties.SFEnummer)[0]) doc.setFillColor(colorList.filter((b) => b.sfe == a.properties.SFEnummer)[0].color);
         doc.rect(15, start, 10, length, "FD");
      });
      top += 5;
      // customCell(doc, left, top, 10, height, " ", 2+jordstykker.length, "left")
      // customCell(doc, left+10, top, 30, height, "", 2+jordstykker.length, "left")
      customCell(doc, left, top, 90, height, "Total", 2 + marker.length, "right", true)
      customCell(doc, left + 90, top, 30, height, arealFormat(10000 * marker.reduce((sum, a) => sum + (parseFloat(a.IMK_areal) * a.overlap / a.area), 0)), 2 + marker.length, "right", true)
      customCell(doc, left + 120, top, 30, height, arealFormat(10000 * marker.reduce((sum, a) => sum + parseFloat(a.IMK_areal), 0)), 2 + marker.length, "right", true)
      customCell(doc, left + 150, top, 30, height, arealFormat(10000 * marker.reduce((sum, a) => sum + parseFloat(a.GBanmeldt), 0)), 2 + marker.length, "right", true)

      if (colorList.filter((b) => b.sfe == a.properties.SFEnummer)[0]) doc.setFillColor(colorList.filter((b) => b.sfe == a.properties.SFEnummer)[0].color);
      doc.rect(15, start, 10, length + (parts.length > 1 ? 0 : height), "FD");


      top += height + 10;
   });

   return doc;
}

function customCell(doc: jsPDF, x, y, width, height, value, ln, align?: TextOptionsLight["align"], bold?: boolean) {
   doc.setDrawColor("#000000");
   doc.rect(x, y, width, height, "S");
   if (bold) {
      doc.setFont(undefined as any, "bold");
   } else {
      doc.setFont(undefined as any, "normal");
   }

   if (align == "right") {
      doc.text(value + "" || " ", x + width - 2, y + 4, { align: align || "left" });
   } else {
      doc.text(value + "" || " ", x + 2, y + 4, { align: align || "left", });
   }
}

function WFSMarkerLag(): number[] {
   return Object.keys(wfsEndpoints["FVM (Føde, Land og Fisk)"].featureTypes).filter((a) => a.startsWith("Marker_")).map((årstal) => {
      return parseInt(årstal.replace("Marker_", ""));
   });
}

function LatestWFSMarkerLag() {
   let years = WFSMarkerLag();
   return Math.max(...years);
}